import { render } from "./FrmWorkerRecordsSearch.vue?vue&type=template&id=22381f5e"
import script from "./FrmWorkerRecordsSearch.vue?vue&type=script&lang=js"
export * from "./FrmWorkerRecordsSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__